module.exports = {
      id: "vikatan-play-usage",
      viewBox: "0 0 27.8 28.8",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#vikatan-play",
      toString: function () {
        return this.url;
      }
    }